import BaseComponentController from '../../../../components/base-component.controller';


class categoryStaticTextController extends BaseComponentController{
    constructor(_, componentRegistryService, constants) {
        super(_, componentRegistryService);
        this.sectionNumber = 0;
        this.appendix1Link = constants.Links.Appendix1;
        this.constants = constants;
    }

    init() {
        this.sectionNumber = this.fnGetCategorySectionNumber();    
    }

    fnGetCategorySectionNumber() {
        if (this.model) {
            switch (this.model.id) {
                case "FinancialInterests":
                    return 1;
                case "Research":
                    return 2;
                case "ClosePersonalRelationshipsBetweenIndividuals":
                    return 3;
                case "ClosePersonalRelationshipsBetweenIndividualsAndStudents":
                    return 4;
                case "PersonalViewsOfIndividualsTowardsOthers":
                    return 5;
                case "SponsorshipsAndOtherAgreements":
                    return 7;
                case "SecondaryEmployment":
                    return 8;
                case "UseOfUniversityFacilitiesAndEquipment":
                    return 9;
                case "UseOfOfficialInformation":
                    return 10;
                case "PersonalBeliefs":
                    return 11;
                case "PublicComment":
                    return 12;
                case "MultipleRoles":
                    return 13;
                // Uncomment if/when the new category is added to the PDF
                // case "ForeignInterference":
                //     return 14;
                default :
                    return 0;
            }
        }
    }

    $onChanges(changesObj) {
        this.model = changesObj.conflictCategory.currentValue;
        this.sectionNumber = this.fnGetCategorySectionNumber();
    }
}

categoryStaticTextController.$inject = ['_', 'componentRegistryService', 'constants'];

let categoryStaticTextComponent = {
    controller: categoryStaticTextController,
    bindings: {
        modelName:'@',
        readonly: '<',
        employmentOptions: '<',
        conflictCategory: '<',
        onUserValidate: '&'
    },
    templateUrl:`app/disclose/conflictOfInterest/components/category-static-text/category-static-text.html`
};

export default categoryStaticTextComponent;


// WEBPACK FOOTER //
// ./app/disclose/conflictOfInterest/components/category-static-text/category-static-text.component.js